module.exports = __webpack_public_path__ + "static/img/15.5777fc6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/zh/15.png
// module id = 2D24
// module chunks = 0